export default {
    props: {
  
        },
    data() {
        return {
  
        };
      },
      computed: {
        url() {
          return this.$store.getters.getdominio
        },
        isHome() {
          if (this.$route.name == 'home' || this.$route.path == "/"  
          || this.$route.path == this.url || this.$route.path == this.url+"/"  ) {
            // console.log('is home')
            // console.log(this.$route)        
            return true    
          } else {
            // console.log('Not home')
            return false
          }
        },   
        isEncuentro2022() {
          if (this.$route.name == 'encuentro2022') {
            // console.log('is encuentro 2022')
            return true    
          } else {
            // console.log('Not encuentro')
            return false
          }  
        }, 
        isEncuentro2024() {
          if (this.$route.name == 'encuentro2024') {
            // console.log('is encuentro 2024')
            return true    
          } else {
            // console.log('Not encuentro')
            return false
          }  
        }, 
        isEncuentro2026() {
          if (this.$route.name == 'encuentro2026') {
            // console.log('is encuentro 2026')
            return true    
          } else {
            // console.log('Not encuentro2026')
            return false
          }  
        }, 
        isEncuentro() {
          if (this.$route.name == 'encuentro' || this.$route.name == 'encuentro2022'
          || this.$route.name == 'encuentro2024' || this.$route.name == 'encuentro2026' ) {
            // console.log('is encuentro')
            return true    
          } else {
            // console.log('Not encuentro')
            return false
          }  
        },   
        isArticulo() {
          if (this.$route.name == 'articulo' || this.$route.path.includes('/articulos/') ) {
            // console.log('is articulo')
            return true    
          } else {
            // console.log('Not articulo')
            return false
          }  
        },
        isProyecto() {
          if (this.$route.name == 'proyecto' || this.$route.path.includes('/caminos/') ) {
            // console.log('is proyecto')
            return true    
          } else {
            // console.log('Not proyecto')
            return false
          }  
        },
        isNovedad() {
          if (this.$route.name == 'novedad' || this.$route.path.includes('/novedades/') ) {
            // console.log('is novedad')
            return true    
          } else {
            // console.log('Not proyecto')
            return false
          }  
        },
        isRecreacion() {
          if (this.$route.name == 'recreacion' || this.$route.path.includes('/recreacion/') ) {
            // console.log('is proyecto')
            return true    
          } else {
            // console.log('Not proyecto')
            return false
          }  
        },
      },
};
